import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import isPageCountOptionsEnabled from 'editor/src/store/hostSettings/selector/isPageCountOptionsEnabled';
import getECommercePageCountOptionIndex from 'editor/src/store/variants/helpers/getECommercePageCountOptionIndex';
import { UNSELECTED_PAGE_COUNT } from 'editor/src/store/variants/reducer/setPageCountReducer';
import { setECommerceProductIdAction, setPageCountAction } from 'editor/src/store/variants/slice';

import { RootState } from 'editor/src/store';
import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

// The page count the requested variant sells, when the editor already holds one to check designs
// against: the host's answer is refused unless it matches.
function expectedPageCount(state: RootState, variantId: string): number | undefined {
  const product = state.variants.eCommerceProduct;
  if (!isPageCountOptionsEnabled(state) || !product || state.variants.selectedPageCount === UNSELECTED_PAGE_COUNT) {
    return undefined;
  }
  const optionIndex = getECommercePageCountOptionIndex(product);
  const variant = product.variants.find(({ id }) => id === variantId);
  const pageCount = optionIndex === -1 ? NaN : parseInt(variant?.optionValues[optionIndex] ?? '', 10);
  return pageCount || undefined;
}

const requestEcommerceVariantOperation =
  (newVariantId: string) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const pageCount = expectedPageCount(getState(), newVariantId);
    sendPostMessage('variants.requestECommerceVariant', { gelatoVariantId: newVariantId });
    batch(() => {
      dispatch(saveUndoRedoStateOperation('ecommerce variant changed'));
      dispatch(setECommerceProductIdAction(newVariantId));
      if (pageCount) {
        dispatch(setPageCountAction(pageCount));
      }
    });
  };

export default requestEcommerceVariantOperation;
